import { shellStringResources } from '../../../Resources/ShellStringResources';
import { IValidatorFn } from '../../../interfaces/IValidatorFn';
import { format } from '../../../shared/utils/string.util';
import { IPatternMetadata } from '../../metadatas/validator/pattern-metadata';
import { IValidatorFactoryService } from './validator-factory.service';

export class PatternValidatorFactoryService implements IValidatorFactoryService<IPatternMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'pattern';

    public createValidatorByMetadata(metadata: IPatternMetadata): IValidatorFn {
        return this.createValidator(metadata.pattern, metadata.errorMessage, metadata.patternFlags);
    }

    public createValidator(pattern: string | RegExp, errMsg?: string, patternFlags?: string): IValidatorFn {
        const regex = typeof pattern === 'string' ? new RegExp(pattern, patternFlags) : new RegExp(pattern);
        const errorMessage = errMsg != null ? errMsg : format(shellStringResources.Validator_ErrorMessage_Pattern, regex.source);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            if (value == null || value === '') {
                return null;
            }
            return regex.test(value) ? null : errorMessage;
        };
    }

    // fixed start/end pattern validator: [entity type] name should start/end with ...
    public createValidatorStartEnd(pattern: string | RegExp, errMsg: string, patternFlags?: string): IValidatorFn {
        const regex = typeof pattern === 'string' ? new RegExp(pattern, patternFlags) : new RegExp(pattern);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            if (value == null || value === '') {
                return null;
            }
            return regex.test(value) ? null : errMsg;
        };
    }
}
